import type { DMConversationMessage } from '@/components/pages/conversations/SocialInbox/types';

export class BaseMedia {
    id: string;
    medium_thumbnail: string;
    min_thumbnail: string;
    original: string;
    original_medium_thumbnail: string;
    original_min_thumbnail: string;

    constructor(attachment: DMConversationMessage['attachments'][0]) {
        this.id = attachment.url;
        this.medium_thumbnail = attachment.preview_url || attachment.url;
        this.min_thumbnail = attachment.preview_url || attachment.url;
        this.original = attachment.url;
        this.original_medium_thumbnail = attachment.url;
        this.original_min_thumbnail = attachment.url;
    }
}
